import { render, staticRenderFns } from "./HumanManagementIndex.vue?vue&type=template&id=d2e22b66&scoped=true"
import script from "./HumanManagementIndex.vue?vue&type=script&lang=js"
export * from "./HumanManagementIndex.vue?vue&type=script&lang=js"
import style0 from "./HumanManagementIndex.vue?vue&type=style&index=0&id=d2e22b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e22b66",
  null
  
)

export default component.exports